import { Box, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import { Asset, Maybe } from "../../models/schema";

const Logo = ({
  logo,
  size = "small"
}: {
  logo: Maybe<Asset> | undefined;
  size?: "small" | "large";
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: size === "small" ? theme.spacing(18) : theme.spacing(24),
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
      <img
        style={{ width: "inherit" }}
        src={logo?.url as string}
        alt={logo?.description as string}
        onClick={() => navigate(routes.home)}
      />
    </Box>
  );
};

export default Logo;
